module.exports = __webpack_public_path__ + "static/subtle-preview-5d3f808bb7efb936c6fd0d0d54e24c0c.png";